import {
  View,
  Text,
  Modal,
  TouchableOpacity,
  Image,
  ScrollView,
} from "react-native";
import React from "react";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { LinearGradient } from "expo-linear-gradient";
import { useNavigation } from "@react-navigation/native";

import { navigateToScreen } from "../../../utility/NavigationHelper";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppScreens } from "../../Utility/AppScreens";
import { AppImages } from "../../../utility/AppImages";
import { AppColors } from "../../../utility/AppColors";

export default function ChallengeSentSuccessfulyModal(props) {
  const navigation = useNavigation();
  const {
    showModal = false,
    setShowModal,
    eventID,
    platformStatus,
    eventDetails,
    onClose,
  } = props;

  const isTwitchSelected = eventDetails?.liveStreamWithTwitch;
  const isTwitchConnected =
    isTwitchSelected && platformStatus.Twitch !== "Not connected";
  const isYouTubeConnected =
    !isTwitchSelected && platformStatus.YouTube !== "Not connected";

  const platformNotConnected = isTwitchSelected
    ? !isTwitchConnected
    : !isYouTubeConnected;

  const onCloseClick = () => {
    setShowModal(false);
    if (onClose) {
      onClose();
    }
  };

  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const isMobile = deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM;

  return (
    <Modal
      animationType={isMobile ? "slide" : "fade"}
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <LinearGradient
          colors={["#111827", "#000000"]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={[styles.mainView, {
            padding: 24,
            alignItems: "center",
            gap: 24,
            borderRadius: isMobile ? 0 : 8,
            borderTopLeftRadius: isMobile ? 16 : 8,
            borderTopRightRadius: isMobile ? 16 : 8,
            borderWidth: 1.6,
            borderColor: "rgba(239, 68, 68, 0.50)",
            borderBottomWidth: isMobile ? 0 : 1.6,
            // Reduce height when platforms are connected (less content)
            ...(isMobile && !platformNotConnected && {
              height: "60%",
            }),
          }]}
        >
          {/* Header Row */}
          <View
            style={{
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_16,
                { color: AppColors.white },
              ]}
            >
              Challenge Sent!
            </Text>
            <TouchableOpacity
              onPress={() => {
                onCloseClick();
              }}
            >
              <Image
                source={AppImages.icCloseWhite}
                style={{
                  height: 20,
                  width: 20,
                }}
              />
            </TouchableOpacity>
          </View>

          {/* Scrollable Content Area */}
          <ScrollView
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{ gap: 24, paddingBottom: 12 }}
          >
            {/* Inner Content Box */}
            <LinearGradient
              colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
              start={{ x: 0, y: 0 }}
              end={{ x: 1, y: 1 }}
              style={{
                width: "100%",
                minHeight: isMobile ? 200 : 280,
                padding: isMobile ? 16 : 24,
                borderRadius: 8,
                borderWidth: 0.8,
                borderColor: "#374151",
                alignItems: "center",
                justifyContent: "center",
                gap: 12,
              }}
            >
              <Image
                source={AppImages.icChallengeLogo}
                style={{
                  height: isMobile ? 80 : 100,
                  width: isMobile ? 80 : 100,
                  resizeMode: "contain",
                }}
              />

              <Text
                style={{
                  color: "#51AF07",
                  textAlign: "center",
                  fontSize: 14,
                  fontWeight: "800",
                }}
              >
                Success!
              </Text>

              <Text
                style={{
                  color: "#FFF",
                  textAlign: "center",
                  fontSize: isMobile ? 16 : 24,
                  fontWeight: "600",
                  lineHeight: isMobile ? 22 : 36,
                }}
              >
                Your challenge has been successfully sent
              </Text>

              <Text
                style={{
                  color: "#FFF",
                  textAlign: "center",
                  fontSize: isMobile ? 14 : 18,
                  fontWeight: "600",
                  lineHeight: isMobile ? 18 : 21,
                  maxWidth: 500,
                }}
              >
                {platformNotConnected
                  ? "Now, set up your streaming platform and KO Broadcaster to prepare for the event."
                  : "Your streaming platform and OBS are already connected. Are you ready to jump into your event?"}
              </Text>
            </LinearGradient>

            {/* Connect Platform Card - Only if not connected */}
            {platformNotConnected && (
              <LinearGradient
                colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 1 }}
                style={{
                  width: "100%",
                  padding: 12,
                  borderRadius: 8,
                  borderWidth: 0.8,
                  borderColor: "#374151",
                  gap: 12,
                }}
              >
                <View>
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_16,
                      {
                        color: AppColors.white,
                        textAlign: "center",
                      }]}
                  >
                    Connect Your Streaming Platform
                  </Text>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_13,
                      {
                        color: "#C4C4C4",
                        textAlign: "center",
                      }]}
                  >
                    Head to Settings {'>'} Streaming Platforms and link your preferred platform (YouTube, Twitch).
                  </Text>
                </View>

                <Image
                  source={AppImages.icAcceptEventPlatformImage}
                  style={{
                    height: 128,
                    width: "100%",
                    resizeMode: "contain",
                    alignSelf: "stretch",
                  }}
                />
              </LinearGradient>
            )}

            {/* Bottom Buttons */}
            <View
              style={{
                width: "100%",
                flexDirection: "row",
                justifyContent: "space-between",
                gap: 16,
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  setShowModal(false);
                  if (onClose) onClose();
                  navigateToScreen(navigation, AppScreens.DrawerRoute);
                }}
                style={{
                  paddingVertical: 12,
                  paddingHorizontal: 16,
                  borderRadius: 8,
                  borderWidth: 1,
                  borderColor: "#FFF",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text style={{ color: "#FFF", fontSize: 14, fontWeight: "700" }}>
                  {platformNotConnected ? "Do it later" : "Go to dashboard"}
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => {
                  setShowModal(false);
                  if (onClose) onClose();
                  if (platformNotConnected) {
                    navigateToScreen(navigation, AppScreens.SettingWebScreen, { tab: "streamSettings" });
                  } else {
                    navigateToScreen(navigation, AppScreens.OnGoingEvents, {
                      eventID: eventID,
                    });
                  }
                }}
                style={{
                  paddingVertical: 12,
                  paddingHorizontal: 16,
                  borderRadius: 8,
                  backgroundColor: "#DC2626",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text style={{ color: "#FFF", fontSize: 14, fontWeight: "700" }}>
                  {platformNotConnected ? "Go to Settings" : "Open Event page"}
                </Text>
              </TouchableOpacity>
            </View>
          </ScrollView>
        </LinearGradient>
      </View>
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      maxWidth: 600,
      backgroundColor: AppColors.black_121212,
      marginHorizontal: 30,
      alignSelf: "center",
      borderRadius: 12,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        maxWidth: 600,
        backgroundColor: "#18151b",
        marginHorizontal: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "center",
        alignItems: "center",
      },
      mainView: {
        maxWidth: 600,
        backgroundColor: "#18151b",
        marginHorizontal: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "flex-end",
        alignItems: "center",
      },
      mainView: {
        width: "100%",
        height: "80%",
        backgroundColor: "#18151b",
        marginHorizontal: 0,
        alignSelf: "center",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "flex-end",
        alignItems: "center",
      },
      mainView: {
        width: "100%",
        height: "80%",
        backgroundColor: "#18151b",
        marginHorizontal: 0,
        alignSelf: "center",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
    },
  }
);
